import api from 'services/api';
import { getEESelector, getEEAction } from 'Common/ee/registry';
import { showModalImportDashboard } from 'Screens/Contextualization/Dashboard/actions/Actions';
import {
  selectWorkspaceList, selectWorkspacesSelected,
  selectLastSelected, selectShowInactive,
  selectShowWsDetail, selectShowGridView, selectIsFetchingPreview,
  selectShowGridViewContext, selectWorkspacesForListView,
  selectWorkspacesAdvancedFilterQueryParam,
  selectWorkspacesQueryParam,
  selectIsFetching,
  selectRowsPerPageListView
} from 'store/Workspace/selectors';
import {
  getVulnsCountInAllWorkspaces,
  setInitialAmountOfVulns,
  updateCurrentWorkspaceOnEdit as setFaradayWorkspace,
  WORKSPACE_EDITED_UPDATE
} from 'Screens/Contextualization/Faraday/actions/Actions';
import { workspaceIsInWorkspaceActivity, removeWorkspaceFromWorkspaceActivity } from 'Screens/Contextualization/Faraday/functions';
import { ACTIONS, CATEGORIES } from 'tracking/GA/constants';
import { trackEvent } from 'tracking/GA';
import { updatePreferences } from 'store/Preferences/actions';
import { selectWorkspaceActivity } from 'store/Preferences/workspace/selectors';
import get from 'lodash/get';
import { openModal, closeModal } from 'store/modals/actions';
import { MODAL_UPGRADE_LICENSE, MODAL_WORKSPACE_CREATE, MODAL_WORKSPACE_GROUPING_CONFIRM, MODAL_WORKSPACE_UPDATE_NAME } from 'store/modals/modals';
import { selectMaxWorkspacesLimit } from 'store/Config/selector';
import { selectCurrentWorkspace, selectCurrentWorkspaceData, selectUserName, selectUserRole } from 'store/Faraday/selectors';
import {
  selectCurrentWsName,
  selectWsEditCreateName,
  selectWsEditCreateDescription,
  selectWsEditCreateStart,
  selectWsEditCreateEnd,
  selectWsEditCreateId,
  selectScope,
  selectWsEditActive,
  selectWsEditCustomer,
  selectWsEditReadonly,
  selectWsEditCreateMakePublic,
  selectWsEditCreateCurrentUsers,
  selectWsEditCreateImportance,
  selectWsEditGroupBy,
  selectWsEditGroupByMatchPrecision,
  selectWsEditGroupByAlgorithm,
  selectWsEditRiskScoreProfile
} from 'store/WorkspaceEditCreate/selectors';
import { redirect } from 'store/Router/actions';
import { unSelectAll as unSelectAllHosts } from 'store/Host/actions';
import { unSelectAll as unSelectAllServices } from 'store/Services/actions';
import { unselectAllCredentials, showCredentialDetail } from 'store/Credentials/actions';
import { unSelectAll as unSelectAllVulns, resetVulnerabilityDetail } from 'store/Manage/actions';
import {
  setPageNumber, clearFilters,
  setFilter, setOrderBy,
  setFilterError,
  removeFiltersByKey
} from 'store/Filters/actions';
import { selectAdvancedFilter, selectPage, selectRowsPerPage } from 'store/Filters/selectors';
import { setError } from 'store/errors/actions';
import { selectPathname } from 'store/Router/selectors';
import filter from 'lodash/filter';
import { ADD_COMMAND, expandProcessingQueue, showProcessingQueue } from 'Common/Components/FileUploadContext/Context/actions';
import { extractIsGroupingFromResponse } from 'Common/Functions/vulnerabilityNameEdit';

export const SET_FIELD = 'SET_FIELD';
export const GET_DATA_WORKSPACE_START = 'GET_DATA_WORKSPACE_START';
export const GET_DATA_WORKSPACE_FAIL = 'GET_DATA_WORKSPACE_FAIL';
export const GET_DATA_WORKSPACE_SUCCESS = 'GET_DATA_WORKSPACE_SUCCESS';
export const WORKSPACE_SELECTED_FOR_WORKING = 'WORKSPACE_SELECTED_FOR_WORKING';
export const GET_WORKSPACES_FOR_WORKING_STARTED = 'GET_WORKSPACES_FOR_WORKING_STARTED';
export const GET_WORKSPACES_FOR_WORKING_SUCCESS = 'GET_WORKSPACES_FOR_WORKING_SUCCESS';
export const GET_WORKSPACES_FOR_WORKING_FAILURE = 'GET_WORKSPACES_FOR_WORKING_FAILURE';
export const WORKSPACE_CREATE_UPDATE_START = 'WORKSPACE_CREATE_UPDATE_START';
export const WORKSPACE_CREATE_UPDATE_SUCCESS = 'WORKSPACE_CREATE_UPDATE_SUCCESS';
export const WORKSPACE_ENABLE_DISABLE = 'WORKSPACE_ENABLE_DISABLE';
export const STOP_REDIRECT = 'STOP_REDIRECT';
export const CONTEXT_WORKSPACE_SELECTED = 'CONTEXT_WORKSPACE_SELECTED';
export const DELETE_WORKSPACES = 'DELETE_WORKSPACES';
export const WORKSPACE_UPDATE_SUCCESS = 'WORKSPACE_UPDATE_SUCCESS';
export const SET_VISIBILITY_CREATE_MODAL_WORKSPACE = 'SET_VISIBILITY_CREATE_MODAL_WORKSPACE';
export const WORKSPACE_CREATION_ERROR = 'WORKSPACE_CREATION_ERROR';
export const SET_USERS_WORKSPACES = 'SET_USERS_WORKSPACES';
export const SET_ASSIGNABLE_USERS_WORKSPACE = 'SET_ASSIGNABLE_USERS_WORKSPACE';
export const CONTEXT_WORKSPACE_UPDATE_SUCCESS = 'CONTEXT_WORKSPACE_UPDATE_SUCCESS';
export const SET_WORKSPACE_FOR_EDIT = 'SET_WORKSPACE_FOR_EDIT';
export const WORKSPACE_MASSIVE_UPDATE_FAIL = 'WORKSPACE_MASSIVE_UPDATE_FAIL';
export const WORKSPACE_MASSIVE_UPDATE_SUCCESS = 'WORKSPACE_MASSIVE_UPDATE_SUCCESS';
export const MORE_OPTIONS_STATUS_CHANGE_WORKSPACE = 'MORE_OPTIONS_STATUS_CHANGE_WORKSPACE';
export const SET_STATUS_MODAL_ASSIGN_USERS_WORKSPACE = 'SET_STATUS_MODAL_ASSIGN_USERS_WORKSPACE';
export const TOGGLE_INACTIVE_FLAG = 'TOGGLE_INACTIVE_FLAG';
export const GET_DATA_WORKSPACES_SUCCESS = 'GET_DATA_WORKSPACES_SUCCESS';
export const WORKSPACE_SHOW_GRID_VIEW = 'WORKSPACE_SHOW_GRID_VIEW';
export const CURRENT_WORKSPACE_EDITED_UPDATE = 'CURRENT_WORKSPACE_EDITED_UPDATE';
export const SET_CURRENT_WORKSPACE_AS_INVALID = 'SET_CURRENT_WORKSPACE_AS_INVALID';
export const SET_SHOW_WORKSPACE_VALIDATOR = 'SET_SHOW_WORKSPACE_VALIDATOR';

export const RESET_STATE_WORKSPACE_CREATE_UPDATE = 'RESET_STATE_WORKSPACE_CREATE_UPDATE';
export const WORKSPACE_CREATE_UPDATE_FAIL = 'WORKSPACE_CREATE_UPDATE_FAIL';
export const UNSELECT_ALL_WORKSPACES = 'UNSELECT_ALL_WORKSPACES';
export const WORKSPACE_UNSELECTED = 'WORKSPACE_UNSELECTED';
export const NEW_PIVOT = 'NEW_PIVOT';
export const SELECT_ALL_WORKSPACES = 'SELECT_ALL_WORKSPACES';
export const WORKSPACE_SELECTED_FROM_GRID_VIEW = 'WORKSPACE_SELECTED_FROM_GRID_VIEW';
export const SHOW_WORKSPACE_DETAIL = 'SHOW_WORKSPACE_DETAIL';
export const WORKSPACE_DETAILS_START = 'WORKSPACE_DETAILS_START';
export const WORKSPACE_DETAILS_SUCCESS = 'WORKSPACE_DETAILS_SUCCESS';
export const WORKSPACE_DETAILS_FAIL = 'WORKSPACE_DETAILS_FAIL';
export const HIDE_WORKSPACE_DETAIL = 'HIDE_WORKSPACE_DETAIL';
export const REFRESH_WS = 'REFRESH_WS';
export const REFRESH_WS_FAIL = 'REFRESH_WS_FAIL';
export const REFRESH_WS_START = 'REFRESH_WS_START';
export const RESET_REFRESH_WS = 'RESET_REFRESH_WS';
export const CONTEXT_WORKSPACE_CREATE_UPDATE_FAIL = 'CONTEXT_WORKSPACE_CREATE_UPDATE_FAIL';

export const GET_WORKSPACE_STATS_START = 'GET_WORKSPACE_STATS_START';
export const GET_WORKSPACE_STATS_SUCCESS = 'GET_WORKSPACE_STATS_SUCCESS';
export const GET_WORKSPACE_STATS_FAIL = 'GET_WORKSPACE_STATS_FAIL';

export const GET_WORKSPACES_FOR_SELECTOR_START = 'GET_WORKSPACES_FOR_SELECTOR_START';
export const GET_WORKSPACES_FOR_SELECTOR_SUCCESS = 'GET_WORKSPACES_FOR_SELECTOR_SUCCESS';
export const GET_WORKSPACES_FOR_SELECTOR_FAIL = 'GET_WORKSPACES_FOR_SELECTOR_FAIL';
export const GET_WORKSPACES_FOR_LIST_VIEW_SUCCESS = 'GET_WORKSPACES_FOR_LIST_VIEW_SUCCESS';

export const SET_FETCHING_PREVIEW = 'SET_FETCHING_PREVIEW';
export const RESET_ERROR_VALUE = 'RESET_ERROR_VALUE';
export const CONTEXT_WORKSPACE_MASSIVE_UPDATE_SUCCESS = 'CONTEXT_WORKSPACE_MASSIVE_UPDATE_SUCCESS';
export const CONTEXT_GET_DATA_WORKSPACES_SUCCESS = 'CONTEXT_GET_DATA_WORKSPACES_SUCCESS';

export const SET_WORKSPACES_FILTER_ERROR = 'SET_WORKSPACES_FILTER_ERROR';
export const WORKSPACES_RESET_STATE = 'WORKSPACES_RESET_STATE';
export const SET_UPDATE_FIELD = 'SET_UPDATE_FIELD';
export const SET_UPDATE_VALUE = 'SET_UPDATE_VALUE';

export const WORKSPACE_SELECTED = 'WORKSPACE_SELECTED';
export const SET_ERROR = 'SET_ERROR';
export const RESET_WS_CREATE_ERROR = 'RESET_WS_CREATE_ERROR';
export const SET_PENDING_WORKSPACE_UPDATE = 'SET_PENDING_WORKSPACE_UPDATE';
export const SET_SHOW_GROUPING_CONFIRM = 'SET_SHOW_GROUPING_CONFIRM';

export const resetState = () => (dispatch) => dispatch({ type: WORKSPACES_RESET_STATE });

export function resetCreationState () {
  return (dispatch) => {
    dispatch({
      type: RESET_STATE_WORKSPACE_CREATE_UPDATE
    });
  };
}

export function getWorkspaces (histogram = true, stats = true, onlyTotalVulns = false) {
  return async (dispatch) => {
    try {
      dispatch({ type: GET_WORKSPACES_FOR_WORKING_STARTED });
      const response = await api.workspace.fetchWorkspaces({}, histogram, !stats, false, onlyTotalVulns);
      const data = response.rows;
      const count = response.count;
      dispatch({ type: GET_WORKSPACES_FOR_WORKING_SUCCESS, data, count });
    } catch (e) {
      dispatch({ type: GET_WORKSPACES_FOR_WORKING_FAILURE, data: e.message || 'Failed to obtain workspaces.' });
    }
  };
}

// Summary: select a workspace for user to work
export function workspaceSelectedForWorking (workspace) {
  return (dispatch) => {
    dispatch({ type: WORKSPACE_SELECTED_FOR_WORKING, workspace, redirect: true });
  };
}

export function stopRedirect () {
  return (dispatch) => {
    dispatch({ type: STOP_REDIRECT });
  };
}

const setWorkspacesFilterError = () => async (dispatch) => dispatch({ type: SET_WORKSPACES_FILTER_ERROR });

export function getData (histogram = true, stats = true, onlyTotalVulns = false) {
  return async (dispatch, getState) => {
    dispatch({ type: GET_DATA_WORKSPACE_START });
    const state = getState();
    const hasAdvancedFilter = selectAdvancedFilter(state, 'workspaces');
    let advancedFilterQueryParam = [];
    if (hasAdvancedFilter) {
      try {
        advancedFilterQueryParam = selectWorkspacesAdvancedFilterQueryParam(state);
      } catch (e) {
        dispatch(setFilterError('workspaces', 'Syntax error. Please try again. For further help check our documentation'));
        return dispatch(setWorkspacesFilterError());
      }
    }

    const standardQueryParam = selectWorkspacesQueryParam(state);

    const params = hasAdvancedFilter ? advancedFilterQueryParam : standardQueryParam;
    const showGridView = selectShowGridViewContext(getState());
    const showListView = !showGridView;
    try {
      const response = await api.workspace.fetchWorkspaces(params, histogram, !stats, showListView, onlyTotalVulns);
      const data = response.rows;
      const count = response.count;
      const pathname = selectPathname(getState());
      if ((pathname.startsWith('/workspaces')) && showListView) return dispatch({ type: GET_WORKSPACES_FOR_LIST_VIEW_SUCCESS, data, count });
      else return dispatch({ type: CONTEXT_GET_DATA_WORKSPACES_SUCCESS, data, count });
    } catch (error) {
      return dispatch({ type: GET_DATA_WORKSPACE_FAIL, error: get(error, 'message', 'An error has occurred.') });
    }
  };
}

export function getDataForListView (histogram = false, stats = false, onlyTotalVulns = true) {
  return async (dispatch, getState) => {
    dispatch({ type: GET_DATA_WORKSPACE_START });
    const state = getState();
    const hasAdvancedFilter = selectAdvancedFilter(state, 'workspaces');
    let advancedFilterQueryParam = [];
    if (hasAdvancedFilter) {
      try {
        advancedFilterQueryParam = selectWorkspacesAdvancedFilterQueryParam(state);
      } catch (e) {
        dispatch(setFilterError('workspaces', 'Syntax error. Please try again. For further help check our documentation'));
        return dispatch(setWorkspacesFilterError());
      }
    }

    const standardQueryParam = selectWorkspacesQueryParam(state);
    const params = hasAdvancedFilter ? advancedFilterQueryParam : standardQueryParam;

    try {
      const response = await api.workspace.fetchWorkspaces(params, histogram, stats, true, onlyTotalVulns);
      const data = response.rows;
      const count = response.count;
      return dispatch({ type: GET_WORKSPACES_FOR_LIST_VIEW_SUCCESS, data, count });
    } catch (error) {
      return dispatch({ type: GET_DATA_WORKSPACE_FAIL, error: get(error, 'message', 'An error has occurred.') });
    }
  };
}

export function enableDisable (ws, value) {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const { workspaceList, workspacesForListView } = state.workspace;
      const showGridView = selectShowGridViewContext(state);
      const showHistogram = !!showGridView;
      const workspaces = showGridView ? workspaceList : workspacesForListView;
      const activeWorkspaces = await api.workspace.getActiveWorkspaces(); // obtengo el total de workspaces activos.
      const maxWsLimit = selectMaxWorkspacesLimit(getState());
      if (!value && maxWsLimit !== null && get(activeWorkspaces, 'length', 0) >= maxWsLimit) {
        dispatch(openModal(MODAL_UPGRADE_LICENSE));
      } else {
        dispatch({ type: WORKSPACE_ENABLE_DISABLE });

        await api.workspace.updateWorkspace(ws, { active: value });

        const newWs = workspaces.filter((workspace) => workspace.name === ws)[0];
        newWs.active = !value;

        dispatch({ type: CONTEXT_WORKSPACE_UPDATE_SUCCESS, ws: newWs });
        dispatch(getData(showHistogram));
      }
    } catch (e) {
      dispatch({ type: CONTEXT_WORKSPACE_CREATE_UPDATE_FAIL, error: get(e, 'messages.json.name[0]', 'An error has occurred.') });
    }
  };
}

export const fetchWorkspaceDetails = (ws) => async (dispatch) => {
  dispatch({ type: 'WORKSPACE_DETAILS_START' });

  try {
    const data = await api.workspace.getWsStats(ws);

    dispatch({ type: WORKSPACE_DETAILS_SUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: WORKSPACE_DETAILS_FAIL, error: get(e, 'message', 'Error fetching workspace details') });
    return null;
  }
};

export function changeReadOnly (ws, readonly) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: WORKSPACE_ENABLE_DISABLE, ws });
      const showGridView = selectShowGridViewContext(getState());
      const showHistogram = !!showGridView;
      await api.workspace.updateWorkspace(ws, { readonly });
      const newWs = await api.workspace.getWsStats(ws);

      if (newWs) {
        dispatch({ type: CONTEXT_WORKSPACE_UPDATE_SUCCESS, ws: newWs }); // update the workspace store
        dispatch({ type: WORKSPACE_EDITED_UPDATE, ws: newWs }); // update faraday store
      }

      dispatch(getData(showHistogram));
    } catch (e) {
      dispatch({ type: CONTEXT_WORKSPACE_CREATE_UPDATE_FAIL, error: 'An error has occurred' });
    }
  };
}

// Summary: Add workspace selected to state. // se usa para la tabla
export function selectWorkspace (workspaceSelected) {
  return (dispatch) => {
    dispatch({
      type: WORKSPACE_SELECTED_FROM_GRID_VIEW, workspaceSelected
    });
  };
}

// Summary: delete workspace/s from database
export function deleteWorkspaceSelected (onClose) {
  return async (dispatch, getState) => {
    const state = getState();
    const workspacesSelected = selectWorkspacesSelected(state);
    const wsActivity = selectWorkspaceActivity(state);
    const showGridView = selectShowGridViewContext(state);
    const showHistogram = !!showGridView;
    const currentPage = selectPage('workspaces', state);
    const rowsPerPage = showGridView ? selectRowsPerPage('workspaces', state) : selectRowsPerPageListView(state);
    const workspaceCount = get(state, 'workspace.workspaceCount', 0);
    dispatch({ type: DELETE_WORKSPACES });

    // TODO: Modify backend, so it should receive an array and return message
    // when some workspaces could not be deleted. Then, add request.
    try {
      const promises = workspacesSelected.map((ws) => {
        const promise = api.workspace.deleteWorkspace(ws.name);
        dispatch(trackEvent(CATEGORIES.workspace, ACTIONS.deleteWorkspace.name, ACTIONS.deleteWorkspace.label, ws.id));
        return promise;
      });

      await Promise.all(promises);
      const newWsActivity = wsActivity.filter((ws) => workspacesSelected.every((selected) => ws !== selected.name));
      dispatch(updatePreferences({ workspaceActivity: newWsActivity }));
      const nextWorkspaceCount = Math.max(workspaceCount - workspacesSelected.length, 0);
      const lastValidPage = Math.max(Math.ceil(nextWorkspaceCount / rowsPerPage), 1);
      if (currentPage > lastValidPage) {
        dispatch(setPageNumber('workspaces', lastValidPage));
      }
      onClose && onClose();
      dispatch(getVulnsCountInAllWorkspaces());
    } catch (e) {
      dispatch(setError(e?.message || 'There was an error, please try again'));
      onClose && onClose();
    }
    dispatch({ type: UNSELECT_ALL_WORKSPACES });
    // await dispatch(getWorkspaces(showHistogram));
    await dispatch(getData(showHistogram, showGridView, !showGridView));
  };
}

export function getUsers () {
  return async (dispatch) => {
    try {
      const users = await api.users.getUsers();
      const mappedUsers = users.rows.map((user) => user.doc);
      return dispatch({ type: SET_USERS_WORKSPACES, users: mappedUsers });
    } catch (e) {
      return dispatch({ type: '' });
    }
  };
}

// Endpoint may return either a flat array of users or the { rows: [{ doc }] } shape used by getUsers().
export function getAssignableUsers (wsName) {
  return async (dispatch) => {
    try {
      const users = await api.users.getAssignableUsers(wsName);
      const mappedUsers = Array.isArray(users) ? users : users.rows.map((user) => user.doc);
      return dispatch({ type: SET_ASSIGNABLE_USERS_WORKSPACE, assignableUsers: mappedUsers });
    } catch (e) {
      return dispatch({ type: '' });
    }
  };
}

function getUpdatedFields (existingObj, newObj) {
  return Object.keys(newObj).reduce((acc, key) => {
    if (typeof newObj[key] === 'object' && newObj[key] !== null && !Array.isArray(newObj[key])) {
      const updatedNestedObj = getUpdatedFields(existingObj[key], newObj[key]);
      if (Object.keys(updatedNestedObj).length > 0) {
        acc[key] = updatedNestedObj;
      }
    } else if (JSON.stringify(existingObj[key]) !== JSON.stringify(newObj[key])) {
      acc[key] = newObj[key];
    }
    return acc;
  }, {});
}

const clampThreshold = (v) => {
  const n = Number(v);
  if (Number.isNaN(n)) return 80;
  return Math.min(100, Math.max(10, n));
};

const normalizeGroupByForPayload = (groupby) => {
  const normalized = String(groupby ?? '').trim().toLowerCase();

  if (!normalized || normalized === 'none' || normalized === 'null') return null;
  if (normalized === 'name' || normalized === 'cve') return normalized;

  return undefined;
};

const buildGroupingPayload = ({ groupby, matchPrecision, groupAlgorithm }) => {
  const group_by = normalizeGroupByForPayload(groupby);

  if (group_by === 'name') {
    return {
      group_by,
      group_algorithm: groupAlgorithm || 'levenshtein',
      group_threshold: clampThreshold(matchPrecision ?? 80)
    };
  }

  if (group_by === 'cve' || group_by === null) {
    return { group_by };
  }

  return {
    group_by: undefined
  };
};

export function createUpdateWorkspace (exploreWs) {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const currentWsName = selectCurrentWsName(state);
      const name = selectWsEditCreateName(state);
      const description = selectWsEditCreateDescription(state);
      const start = selectWsEditCreateStart(state);
      const end = selectWsEditCreateEnd(state);
      const id = selectWsEditCreateId(state);
      const scope = selectScope(state);
      const currentWorkspace = selectCurrentWorkspace(state);
      const currentWorkspaceData = selectCurrentWorkspaceData(state);
      const active = selectWsEditActive(state);
      const customer = selectWsEditCustomer(state);
      const readonly = selectWsEditReadonly(state);
      const isPublic = selectWsEditCreateMakePublic(state);
      const currentUsers = selectWsEditCreateCurrentUsers(state);
      const importance = selectWsEditCreateImportance(state);
      const showGridView = selectShowGridViewContext(state);
      const showHistogram = !!showGridView;
      const userRole = selectUserRole(state);
      const currentUser = selectUserName(state);
      const defaultUserRoles = ['admin', 'asset_owner', 'pentester', 'client', 'workspace_admin'];
      const isCustomRole = !defaultUserRoles.includes(userRole);
      // A workspace_admin can only access workspaces they're assigned to, so make sure
      // they're always included even if the wizard's own seeding step was skipped/missed.
      const baseWorkspaceUsers = isCustomRole ? [currentUser] : currentUsers;
      const workspaceUsers = userRole === 'workspace_admin' && !baseWorkspaceUsers.includes(currentUser)
        ? [...baseWorkspaceUsers, currentUser]
        : baseWorkspaceUsers;
      const groupby = selectWsEditGroupBy(state);
      const matchPrecision = selectWsEditGroupByMatchPrecision(state);
      const groupAlgorithm = selectWsEditGroupByAlgorithm(state);
      const riskScoreProfile = selectWsEditRiskScoreProfile(state);

      let wsActivity = selectWorkspaceActivity(state);

      const groupingChanged =
        (currentWorkspaceData?.group_by ?? 'none') !== groupby ||
        (currentWorkspaceData?.group_threshold ?? 80) !== matchPrecision ||
        (currentWorkspaceData?.group_algorithm ?? 'levenshtein') !== groupAlgorithm;

      dispatch({ type: WORKSPACE_CREATE_UPDATE_START });

      // eslint-disable-next-line no-useless-escape
      if (!/[^A-Za-z0-9@._-]/.test(name)) {
        let workspace = {
          name,
          description,
          scope,
          users: workspaceUsers,
          duration: {
            start_date: start ? new Date(start).getTime() : '',
            end_date: end ? new Date(end).getTime() : ''
          },
          importance,
          customer,
          public: isPublic,
          ...buildGroupingPayload({ groupby, matchPrecision, groupAlgorithm })
        };

        if (id) {
          workspace = {
            ...workspace,
            active,
            readonly
          };

          // Compare the new data with the existing data and include only the changed fields
          const updatedWorkspace = getUpdatedFields(currentWorkspaceData, workspace);

          if (id && groupingChanged) {
            dispatch(setField('pendingWorkspaceUpdate', updatedWorkspace));
            dispatch(openModal(MODAL_WORKSPACE_GROUPING_CONFIRM));
            return;
          }

          // Include the ID in the updated workspace
          updatedWorkspace.id = id;

          // Send the PATCH request with only the changed fields
          const newWs = await api.workspace.updateWorkspace(currentWsName, updatedWorkspace);

          const isGroupingFromResponse = extractIsGroupingFromResponse(newWs);
          const commandId = newWs?.command_id;

          if (commandId && isGroupingFromResponse === true) {
            dispatch({
              type: ADD_COMMAND,
              command: {
                command_id: commandId,
                name: `Re-group vulnerabilities (${currentWsName})`,
                workspaceName: currentWsName,
                fileType: 'workspaceGrouping',
                commandType: 'workspaceGrouping',
                isGrouping: true,
                error: false,
                finished: false
              }
            });

            dispatch(showProcessingQueue(true));
            dispatch(expandProcessingQueue(true));
          }

          dispatch({ type: WORKSPACE_UPDATE_SUCCESS, ws: newWs });
          dispatch(trackEvent(CATEGORIES.workspace, ACTIONS.editWorkspace.name, ACTIONS.editWorkspace.label, id));
        } else {
          const response = await api.workspace.createWorkspace(workspace);
          dispatch(trackEvent(CATEGORIES.workspace, ACTIONS.createWorkspace.name, ACTIONS.createWorkspace.label, response.id));

          // Risk score profiles are Enterprise Edition: Core can't call their
          // service directly, so the assignment goes through the registry and
          // is simply skipped when the feature isn't there.
          const assignRiskScoreProfile = getEEAction('assign-workspace-risk-score-profile');
          if (riskScoreProfile && assignRiskScoreProfile) {
            const assigned = await dispatch(assignRiskScoreProfile(name, riskScoreProfile));
            if (!assigned) dispatch(setError('Workspace created, but the risk score profile could not be assigned. You can set it from the workspace details.'));
          }
        }

        dispatch({ type: WORKSPACE_CREATE_UPDATE_SUCCESS });

        if (id && workspaceIsInWorkspaceActivity(wsActivity, currentWorkspace)) {
          wsActivity = removeWorkspaceFromWorkspaceActivity(wsActivity, currentWorkspace);
          dispatch(updatePreferences({ workspaceActivity: wsActivity }));
        }

        if (currentWsName === currentWorkspace && currentWsName !== name) {
          dispatch(setFaradayWorkspace(name, currentWorkspace));
        }

        dispatch(setVisibilityCreateModal(false));
        if (getEESelector('allow-get-users', () => false)(state)) dispatch(getUsers());
        dispatch(getData(showHistogram));

        if (exploreWs) {
          if (!id) dispatch(setInitialAmountOfVulns(name, 0));
          dispatch({ type: WORKSPACE_SELECTED_FOR_WORKING, workspace: name });
          dispatch(redirect(`/manage/${name}`));
        }
      }
    } catch (e) {
      return dispatch({ type: WORKSPACE_CREATE_UPDATE_FAIL, error: e.message ? e.message : 'An error has occurred.' });
    }
  };
}

export function createWorkspaceFromSelector (users) {
  return async (dispatch, getState) => {
    const { name } = getState().workspaceEditCreate;
    const response = await dispatch(createUpdateWorkspace(users));

    if (!response.error) {
      await dispatch(getWorkspaces());
      dispatch({ type: WORKSPACE_SELECTED_FOR_WORKING, workspace: name });
      dispatch(redirect(`/feed/${name}`));
    }
    return dispatch({ type: '' });
  };
}

export function resetErrorMessage () {
  return (dispatch) => dispatch({ type: WORKSPACE_CREATE_UPDATE_FAIL, error: '' });
}

export function setVisibilityCreateModal (value) {
  return async (dispatch, getState) => {
    const workspaces = await api.workspace.getActiveWorkspaces(); // obtengo el total de workspaces activos.
    const maxWsLimit = selectMaxWorkspacesLimit(getState());
    if (maxWsLimit !== null && get(workspaces, 'length', 0) >= maxWsLimit) {
      dispatch(openModal(MODAL_UPGRADE_LICENSE));
    } else {
      dispatch({ type: SET_VISIBILITY_CREATE_MODAL_WORKSPACE, value });
      if (!value) dispatch({ type: RESET_STATE_WORKSPACE_CREATE_UPDATE, value });
      if (value) dispatch(openModal(MODAL_WORKSPACE_CREATE));
      else dispatch(closeModal(MODAL_WORKSPACE_CREATE));
    }
  };
}

export function showEditModal () {
  return async (dispatch, getState) => {
    const { workspacesSelected } = getState().workspace;
    try {
      const workspace = await api.workspace.getWsStats(workspacesSelected[0].name);
      dispatch(setVisibilityCreateModal(true));
      return dispatch({ type: SET_WORKSPACE_FOR_EDIT, workspace });
    } catch (e) {
      return dispatch({ type: WORKSPACE_CREATE_UPDATE_FAIL, error: e.message ? e.message : 'An error has occurred.' });
    }
  };
}

export function massiveUpdateWorkspacesActive (active) {
  return async (dispatch, getState) => {
    const { workspacesSelected, workspaceList, workspacesForListView, contextShowGridView } = getState().workspace;
    const showGridView = selectShowGridViewContext(getState());
    const showHistogram = !!showGridView;
    const workspaceNames = workspacesSelected.map((ws) => ws.name);
    try {
      const activeWorkspaces = await api.workspace.getActiveWorkspaces();
      const maxWsLimit = selectMaxWorkspacesLimit(getState());

      if (maxWsLimit !== null && get(activeWorkspaces, 'length', 0) >= maxWsLimit) {
        dispatch(openModal(MODAL_UPGRADE_LICENSE));
      } else {
        const workspacesUpdated = contextShowGridView ? workspaceList : workspacesForListView;
        await api.workspace.updateWorkspaces({ ids: workspaceNames, active });
        dispatch(getData(showHistogram));
        return dispatch({ type: CONTEXT_WORKSPACE_MASSIVE_UPDATE_SUCCESS, workspaces: workspacesUpdated });
      }
    } catch (e) {
      return dispatch({ type: WORKSPACE_MASSIVE_UPDATE_FAIL, error: e.message ? e.message : 'An error has occurred.' });
    }
  };
}

export function moreStatusChange (value) {
  return (dispatch) => {
    dispatch({ type: MORE_OPTIONS_STATUS_CHANGE_WORKSPACE, value });
  };
}

export function setModalAssignUsersStatus (value) {
  return async (dispatch, getState) => {
    const { workspacesSelected, workspaceList, workspacesForListView, contextShowGridView } = getState().workspace;

    try {
      const workspacesUpdated = contextShowGridView ? workspaceList : workspacesForListView;

      await Promise.all(workspacesSelected.map(async (ws) => {
        if (ws.users) return;

        const index = workspacesUpdated.findIndex((workspace) => workspace.id === ws.id);
        const workspaceData = await api.workspace.getWsStats(ws.name);
        workspacesUpdated[index] = { ...ws, users: workspaceData.users };
      }));

      dispatch({ type: CONTEXT_WORKSPACE_MASSIVE_UPDATE_SUCCESS, workspaces: workspacesUpdated });
      return dispatch({ type: SET_STATUS_MODAL_ASSIGN_USERS_WORKSPACE, value });
    } catch (e) {
      return dispatch({ type: WORKSPACE_MASSIVE_UPDATE_FAIL, error: e.message ? e.message : 'An error has occurred.' });
    }
  };
}

export function toggleInactive (showAll) {
  return (dispatch, getState) => {
    const showGridView = selectShowGridViewContext(getState());
    const showHistogram = !!showGridView;
    dispatch({ type: TOGGLE_INACTIVE_FLAG });
    if (!showAll) dispatch(removeFiltersByKey('workspaces', 'active'));
    dispatch(getData(showHistogram));
  };
}

export function workspaceSelectedFromTable (ws) {
  return async (dispatch) => {
    const workspaceName = get(ws, 'name', '');
    const vulns = get(ws, 'stats.total_vulns', 0);
    dispatch(unSelectAllHosts());
    dispatch(unSelectAllServices());
    dispatch(unselectAllCredentials());
    dispatch(showCredentialDetail(false));
    dispatch(unSelectAllVulns());
    dispatch(resetVulnerabilityDetail());
    dispatch({ type: WORKSPACE_SELECTED_FOR_WORKING, workspace: workspaceName });
    dispatch(redirect(`/feed/${workspaceName}`));
    dispatch({ type: GET_WORKSPACE_STATS_SUCCESS, data: ws });
    if (vulns === 0) dispatch(showModalImportDashboard(true));
  };
}

export function setPage (page) {
  return (dispatch, getState) => {
    const showGridView = selectShowGridViewContext(getState());
    const showHistogram = !!showGridView;
    dispatch(setPageNumber('workspaces', page));
    if (showGridView) dispatch(getData(showHistogram));
    else dispatch(getDataForListView(false));
  };
}

export function setWorkspaceFilter (string) {
  return (dispatch, getState) => {
    const showGridView = selectShowGridViewContext(getState());
    const newFilter = { name: 'name', op: 'ilike', val: `%${string}%` };
    if (string) dispatch(setFilter('workspaces', newFilter));
    else dispatch(clearFilters('workspaces'));
    dispatch(getData(showGridView));
  };
}

export function setOrderByWorkspaces (sorting) {
  return async (dispatch, getState) => {
    const state = getState();
    const showGridView = selectShowGridViewContext(state);
    const isFetchingPreview = selectIsFetchingPreview(state);
    const newOrderBy = {
      field: get(sorting, '[0].id', 'update_date'),
      direction: get(sorting, '[0].desc', 'desc') ? 'desc' : 'asc'
    };
    await dispatch(updatePreferences({ workspacesOrderBy: newOrderBy }));
    dispatch(setOrderBy('workspaces', sorting));
    if (!isFetchingPreview) dispatch(getData(showGridView));
  };
}

export function toogleGridView (showGridView) {
  return (dispatch, getState) => {
    dispatch({
      type: WORKSPACE_SHOW_GRID_VIEW, showGridView
    });
    dispatch(setPage(1));
    const isFetching = selectIsFetching(getState());
    if (!isFetching && !showGridView) {
      dispatch(getDataForListView());
    }
  };
}

export function setField (field, value) {
  return (dispatch) => {
    dispatch({
      type: SET_FIELD, field, value
    });
  };
}

// A workspace_admin can only access workspaces they're assigned to, so when creating
// a new one they must be seeded into the assignee list. Reads state at dispatch time
// (instead of closing over React state) so it's never working off a stale snapshot.
export function seedCurrentUserAsAssignee () {
  return (dispatch, getState) => {
    const state = getState();
    const currentUserRole = selectUserRole(state);
    const currentUserName = selectUserName(state);
    const currentUsers = selectWsEditCreateCurrentUsers(state);
    if (currentUserRole === 'workspace_admin' && !currentUsers.includes(currentUserName)) {
      dispatch(setField('users', [...currentUsers, currentUserName]));
    }
  };
}

export function seedAssigneesForEdit (wsName) {
  return async (dispatch) => {
    const { assignableUsers = [] } = await dispatch(getAssignableUsers(wsName));
    if (!assignableUsers.some((u) => u.assigned !== undefined)) return;
    const assignedUsernames = assignableUsers.filter((u) => u.assigned && u.role !== 'admin').map((u) => u.username);
    dispatch(setField('users', assignedUsernames));
  };
}

export function updateWS (ws, value) {
  return async (dispatch, getState) => {
    try {
      const response = await api.workspace.updateWorkspace(ws, value);

      let wsData = response?.ws || response?.workspace || response;

      if (!wsData || Object.keys(wsData).length === 0) {
        wsData = await api.workspace.getWsStats(ws);
      }

      dispatch({ type: CONTEXT_WORKSPACE_UPDATE_SUCCESS, ws: wsData });

      const { contextShowGridView } = getState().workspace;
      if (contextShowGridView) dispatch(getData());

      return response;
    } catch (e) {
      const errorData = e?.json || e?.messages?.json || e;
      const errorMessage =
        errorData?.response?.error ||
        errorData?.message ||
        'An error has occurred.';

      dispatch({ type: CONTEXT_WORKSPACE_CREATE_UPDATE_FAIL, error: errorMessage });
      throw e;
    }
  };
}

const addDeleteController = (workspaces, workspacesList) => { // if all hosts are in hostList then unselect then if not
  const allWorkspacesAreSelected = workspaces.every((testWs) => workspacesList.some((ws) => ws._id === testWs._id));

  if (allWorkspacesAreSelected) return [WORKSPACE_UNSELECTED, workspaces];
  return [CONTEXT_WORKSPACE_SELECTED, workspaces];
};

const selectCalculator = (e, ws, workspacesList, areWorkspacesSelected) => (dispatch, getState) => {
  const pivot = selectLastSelected(getState());
  const index = workspacesList.findIndex((el) => el._id === ws._id);
  const workspacesSelected = selectWorkspacesSelected(getState());

  dispatch({ type: NEW_PIVOT, payload: index });
  if (e.shiftKey && pivot !== -1 && areWorkspacesSelected) {
    const start = Math.min(pivot, index);
    const end = Math.max(pivot, index) + 1;
    const workspaces = workspacesList.slice(start, end);
    const [type, payload] = addDeleteController(workspaces, workspacesSelected);
    return dispatch({ type, payload });
  }
  const [type, payload] = addDeleteController([ws], workspacesSelected);
  return dispatch({ type, payload });
};

export const selectRow = (e, ws) => (dispatch, getState) => {
  const allWorkspaces = selectWorkspaceList(getState());
  const workspacesSelected = selectWorkspacesSelected(getState());
  dispatch(selectCalculator(e, ws, allWorkspaces, workspacesSelected.length > 0));
};

export const unSelectAll = () => (dispatch) => dispatch({ type: UNSELECT_ALL_WORKSPACES });

export const selectAllWorkspaces = () => (dispatch, getState) => {
  const showInactive = selectShowInactive(getState());
  const workspacesSelected = selectWorkspacesSelected(getState());
  const workspacesForListView = selectWorkspacesForListView(getState());
  if (workspacesForListView.length === workspacesSelected.length) return dispatch(unSelectAll());

  if (showInactive) {
    return dispatch({ type: SELECT_ALL_WORKSPACES, workspacesList: workspacesForListView });
  } else {
    const activeWorkspaces = filter(workspacesForListView, { active: true });
    return dispatch({ type: SELECT_ALL_WORKSPACES, workspacesList: activeWorkspaces });
  }
};

export function redirectToWsDetail (ws) {
  return (dispatch) => {
    dispatch(redirect(`/workspaces/${ws}`));
    dispatch({ type: SET_FETCHING_PREVIEW, isFetchingPreview: true });
  };
}

export function closeDetail () {
  return (dispatch) => {
    dispatch(redirect('/workspaces'));
    dispatch({ type: SET_FETCHING_PREVIEW, isFetchingPreview: false });
  };
}

export function loadWorkspaceDetail (ws) {
  return async (dispatch) => {
    try {
      const workspace = await api.workspace.getWsStats(ws);
      dispatch({ type: SHOW_WORKSPACE_DETAIL, workspace });
    } catch (e) {
      dispatch(redirect('/workspaces'));
    }
  };
}

export function hideWorkspaceDetail () {
  return (dispatch, getState) => {
    const showWorkspaceDetail = selectShowWsDetail(getState());
    if (showWorkspaceDetail) dispatch({ type: HIDE_WORKSPACE_DETAIL });
  };
}

export function refreshWs (ws) {
  return async (dispatch) => {
    dispatch({ type: REFRESH_WS_START });
    try {
      const workspace = await api.workspace.getWsStats(ws);
      dispatch({ type: REFRESH_WS, workspace });
    } catch (e) {
      dispatch({ type: REFRESH_WS_FAIL, error: e.message || 'An error has occurred.' });
    }
  };
}

export const resetRefreshWs = () => (dispatch) => {
  return dispatch({ type: RESET_REFRESH_WS });
};

export function getWorkspaceStats (data) {
  return async (dispatch) => {
    dispatch({ type: GET_WORKSPACE_STATS_SUCCESS, data });
  };
}

export function setWsStatsError (error) {
  return (dispatch) => {
    dispatch({ type: GET_WORKSPACE_STATS_FAIL, error });
  };
}

export const setPendingWorkspaceUpdate = (payload) => ({
  type: SET_PENDING_WORKSPACE_UPDATE,
  payload
});

export const setShowGroupingConfirm = (value) => ({
  type: SET_SHOW_GROUPING_CONFIRM,
  value
});

export function getWorkspacesForSelector () {
  return async (dispatch) => {
    dispatch({ type: GET_WORKSPACES_FOR_SELECTOR_START });
    const params = {
      offset: 0,
      limit: 10,
      filters: [{ name: 'active', op: '==', val: 'true' }],
      order_by: [{ field: 'update_date', direction: 'desc' }]
    };

    try {
      const response = await api.workspace.fetchWorkspacesForSelector(params, false, true, true);
      const data = response.rows;
      return dispatch({ type: GET_WORKSPACES_FOR_SELECTOR_SUCCESS, data });
    } catch (error) {
      return dispatch({ type: GET_WORKSPACES_FOR_SELECTOR_FAIL, error });
    }
  };
}

export function getTotalVulns (wsName) {
  return async (dispatch) => {
    dispatch({ type: GET_WORKSPACE_STATS_START });

    try {
      const response = await api.workspace.getWsStats(wsName);
      dispatch(getWorkspaceStats(response));
    } catch (error) {
      dispatch(setWsStatsError(error));
    }
  };
}

export function resetError () {
  return (dispatch) => {
    dispatch({ type: RESET_ERROR_VALUE });
    dispatch({ type: RESET_WS_CREATE_ERROR });
  };
}

export function filterWs () {
  return (dispatch, getState) => {
    const showGridView = selectShowGridViewContext(getState());
    if (showGridView) dispatch(getData());
    else dispatch(getData(false));
  };
}

export function setUpdateField (updateField) {
  return (dispatch) => {
    dispatch({ type: SET_UPDATE_FIELD, updateField });
  };
}

export function setUpdateValue (updateValue) {
  return (dispatch) => {
    dispatch({ type: SET_UPDATE_VALUE, updateValue });
  };
}

export function showUpdateModal () {
  return (dispatch) => {
    dispatch(openModal(MODAL_WORKSPACE_UPDATE_NAME));
  };
}

export function massiveUpdateUsers (selectedUsers) {
  return async (dispatch, getState) => {
    const { workspacesSelected } = getState().workspace;
    const showGridView = selectShowGridView(getState());
    const showHistogram = !!showGridView;

    try {
      const promises = workspacesSelected.map((ws) => api.workspace.updateWorkspace(ws.name, { users: selectedUsers }));
      await Promise.all(promises);

      dispatch(getWorkspaces(showHistogram));
      dispatch(getData(showHistogram));
      dispatch(unSelectAll());
      return dispatch({ type: SET_STATUS_MODAL_ASSIGN_USERS_WORKSPACE, value: false });
    } catch (e) {
      return dispatch({ type: WORKSPACE_MASSIVE_UPDATE_FAIL, error: e.message ? e.message : 'An error has occurred.' });
    }
  };
}

export const setErrorMessage = (error) => (dispatch) => {
  dispatch({ type: SET_ERROR, error });
};
